/** French UI strings - align keys with `TRANSLATIONS.en` */
const fr = {
  menu: {
    home: 'Accueil',
    ourApps: 'Nos apps',
    whoWeAre: 'Qui sommes-nous',
    privacyPolicy: 'Confidentialité',
    contactUs: 'Contact',
    settings: 'Réglages'
  },
  siteFooter: {
    ariaLabel: 'Pied de page',
    rightsReserved: 'Tous droits réservés.'
  },
  home: {
    title: 'Des outils simples. Des progrès réels.',
    intro:
      'Nous pensons que la technologie doit être un partenaire discret dans votre réussite.',
    masterSwedishLabel: 'Maîtriser le suédois :',
    masterSwedishText:
      'Plus de 8 applis linguistiques, dont TalkSvenska et SWGrammar : un écosystème complet pour étudiants et expatriés.',
    simplifyFinancesLabel: 'Simplifiez vos finances :',
    simplifyFinancesText:
      'Des outils comme BillTracker et Curren$ee vous aident à suivre vos dépenses locales et mondiales.',
    designedLabel: 'Conçu pour tous :',
    designedText:
      'Des minuteurs visuels pour les enfants aux puzzles d’ordre des mots avancés : nos applis s’adressent à tous les âges et niveaux.',
    carouselRegion: 'Aperçus des apps ABASHELARI',
    previousImage: 'Image précédente',
    nextImage: 'Image suivante',
    howTitle: 'Ce que vous trouverez dans nos apps',
    howSubtitle:
      'Apprentissage des langues, finances claires et outils familiaux - chaque produit reste utile et ciblé.',
    feature1Title: 'Maîtriser le suédois avec une suite cohérente',
    feature1Desc:
      'SWGrammar, TalkSvenska et les applis SW couvrent grammaire, vocabulaire et phrases, avec étude hors ligne adaptée au quotidien.',
    feature2Title: 'Gardez le contrôle de votre argent au-delà des frontières',
    feature2Desc:
      'BillTracker et Curren$ee rendent abonnements et dépenses lisibles dans les devises que vous utilisez vraiment.',
    feature3Title: 'Des outils calmes pour les enfants et le quotidien',
    feature3Desc:
      'Jeux de lettres, premières lectures et utilitaires comme Time2See - pensés pour la clarté à tout âge.',
    appsStripeTitle: 'Nos apps',
    appsStripeAria: 'Nos apps - touchez une icône pour ouvrir la page',
    appsStripePrev: 'Faire défiler vers la gauche pour plus d’apps',
    appsStripeNext: 'Faire défiler vers la droite pour plus d’apps'
  },
  ourApps: {
    pageTitle: 'Nos apps',
    intro:
      'Du suédis ludique aux utilitaires du quotidien : tout ce que nous publions est ici. Choisissez une app pour lire l’histoire, voir les captures et aller sur l’App Store.',
    readMore: 'Lire la suite',
    downloadLabel: 'Télécharger sur l’App Store',
    appNotFound: 'Application introuvable.',
    screenshotsHeading: 'Captures et vidéo',
    descriptionMore: 'Plus',
    descriptionLess: 'Moins',
    noScreenshotsLead: 'Pas encore de captures. Ajoutez 3 images dans'
  },
  whoWeAre: {
    title: 'Des outils malins pour les esprits curieux.',
    intro:
      'ABASHELARI crée des applis ciblées : apprentissage du suédois, lecture ludique pour enfants et outils pratiques au quotidien. Voici comment notre travail s’articule.',
    section1Title: 'Apprendre le suédois',
    section1Text:
      'La famille « SW » - SWGrammar, SWVerbs, SWVocabulary, SWWorder, SWAdjective et TalkSvenska - forme un écosystème : pratique structurée, explications claires, audio utile et usage hors ligne pour coller à la vie réelle.',
    section2Title: 'Jeux pour enfants : anglais et hébreu',
    section2Text:
      'Nous créons aussi des jeux visuels et doux pour premiers lecteurs : tracer les lettres, lettres et mots, vocabulaire pour l’anglais et l’hébreu. Un temps d’écran utile : répétition comprise des enfants, mise en page lisible et progression respectueuse.',
    section3Title: 'Utilitaires du quotidien',
    section3Text:
      'Au-delà de l’éducation, nous proposons des outils pour les routines : BillTracker pour factures et abonnements, avec vues multi-devises. Curren$ee rend les dépenses lisibles dans les monnaies qui comptent pour vous. Time2See propose des minuteurs visuels pour les enfants. Chaque produit vise rapidité et clarté.',
    section4Title: 'Qui nous sommes - et ce que nous visons',
    section4Text:
      'ABASHELARI est un petit studio indépendant. Nous privilégions le soin du détail et la vie privée plutôt qu’une monétisation agressive : interfaces nettes et respect de votre attention et de vos données. Nous créons des outils concrets - maîtriser le suédois, accompagner les premières lectures ou garder les finances du foyer lisibles - et les améliorons selon l’usage réel.'
  },
  contact: {
    title: 'Contact',
    p1:
      'Une question, une idée - ou juste dire bonjour ? Nous sommes une petite équipe et lisons chaque message. Le plus rapide : nous écrire à l’adresse ci-dessous :',
    p2:
      'Vous pouvez aussi utiliser le formulaire ci-dessous - comme vous préférez. Nous répondrons dès que possible.',
    p3: 'Merci de nous avoir écrit.',
    name: 'Nom',
    emailLabel: 'E-mail',
    message: 'Message',
    messageErrorMin: 'Veuillez saisir au moins 10 caractères dans votre message.',
    messageErrorMax: 'Votre message est limité à 500 caractères.',
    submitSending: 'Envoi en cours…',
    submitSuccess:
      'Merci ! Votre message a été envoyé - nous vous répondrons bientôt.',
    submitError:
      'L’envoi a échoué. Réessayez ou écrivez-nous directement par e-mail.',
    gotIt: 'Compris',
    send: 'Envoyer le message'
  },
  settings: {
    title: 'Réglages',
    languageTitle: 'Langue',
    languageDesc: 'Choisissez la langue utilisée sur tout le site.',
    english: 'Anglais',
    swedish: 'Suédois',
    spanish: 'Espagnol',
    german: 'Allemand',
    french: 'Français'
  },
  privacy: {
    title: 'Politique de confidentialité',
    updated: 'Dernière mise à jour : 3 mars 2025',
    intro:
      'Cette politique décrit comment ABASHELARI collecte, utilise, conserve et protège les informations lorsque vous utilisez notre site et nos applications mobiles.',
    contactHeading: 'Contact',
    contactTextLead: 'Questions sur la confidentialité ? Écrivez-nous à',
    contactTextTrail: '.',
    collectHeading: 'Informations que nous pouvons collecter',
    collectIntro:
      'Selon le produit, nous pouvons collecter des informations limitées nécessaires au service, au support et à la fiabilité.',
    collectItems: [
      'Coordonnées que vous choisissez de fournir (par ex. e-mail lors d’un contact).',
      'Données d’usage et de diagnostic générées par l’app ou le site (rapports de plantage, métriques).',
      'Informations techniques envoyées par les apps et navigateurs (type d’appareil, OS et localisation générale via l’IP le cas échéant).'
    ],
    useHeading: 'Comment nous utilisons les informations',
    useItems: [
      'Pour fournir, maintenir et améliorer nos apps et le site.',
      'Pour répondre au support et communiquer des mises à jour importantes.',
      'Pour comprendre les tendances agrégées et corriger les bugs (en minimisant les données personnelles lorsque possible).'
    ],
    shareHeading: 'Partage et sous-traitants',
    shareText:
      'Nous ne vendons pas vos données personnelles. Nous pouvons partager des informations avec des prestataires qui nous aident à exploiter le service (hébergement, analyse, e-mail), avec des garanties appropriées et seulement si nécessaire.',
    retentionHeading: 'Conservation',
    retentionText:
      'Nous conservons les informations seulement le temps nécessaire aux fins décrites, sauf obligation légale de conservation plus longue.',
    securityHeading: 'Sécurité',
    securityText:
      'Nous prenons des mesures raisonnables pour protéger les informations, mais aucune transmission ou stockage n’est totalement sûr.',
    childrenHeading: 'Confidentialité des enfants',
    childrenText:
      'Nos apps peuvent convenir aux familles. Si vous pensez qu’un enfant a fourni des données sans consentement adapté, contactez-nous et nous prendrons des mesures raisonnables pour les supprimer si nécessaire.',
    thirdHeading: 'Liens vers d’autres sites',
    thirdText:
      'Notre site ou nos apps peuvent renvoyer vers des sites tiers (par ex. App Store). Ces sites ont leurs propres politiques.',
    changesHeading: 'Modifications',
    changesText:
      'Nous pouvons mettre à jour cette politique occasionnellement. Nous actualiserons alors la date de « Dernière mise à jour » et publierons la version révisée.',
    rightsHeading: 'Vos choix',
    rightsText:
      'Selon votre lieu de résidence, vous pouvez avoir des droits d’accès, de rectification ou de suppression de certaines données. Contactez-nous et nous répondrons dans un délai raisonnable.'
  }
};

export default fr;
